// extracted by mini-css-extract-plugin
module.exports = {"ScrollNavItem":"ScrollNavItem_ScrollNavItem__14t8N","ScrollNavItemLink":"ScrollNavItem_ScrollNavItemLink__2PKBi","active":"ScrollNavItem_active__2XsqH"};